import React from "react";
import { Formik } from "formik";
import { observer } from 'mobx-react';
import * as Yup from "yup";
import MultiSelect from "../../../../common/components/input/MultiSelect";
import OptionCard from '../OptionCard';
import RolesDropdown from '../RolesDropdown';
import {
    Button,
    CircularProgress,
} from "@material-ui/core";


const InviteByEmailForm = ({ activeUsers, roles, onSubmit, onRoleCreate, onRoleEdit, onRoleDelete, store, loadingRoles }) => {
    const defaultRole = roles.find(role => role.name == "Admin Users");
    let sharedUserEmails = store.sharedUsers.map(user => user.email) || [];
    return (
        <Formik
            initialValues={{ emails: [], role_id: defaultRole?.id || "" }}
            onSubmit={async (values, { resetForm }) => {
                await new Promise(resolve => {
                    onSubmit(values, (isFailed = false) => {
                        resolve();
                        if (!isFailed) {
                            resetForm();
                        }
                    });
                });
            }}
            validationSchema={
                Yup.object().shape({
                    emails: Yup.array().of(Yup.string().email()).required("Please enter email"),
                })
            }
        >
            {
                props => {
                    const {
                        values,
                        touched,
                        errors,
                        dirty,
                        isSubmitting,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        handleReset
                    } = props;
                    return (
                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'flex', paddingTop: 10 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 10 }}>
                                    <MultiSelect
                                        id="emails"
                                        options={activeUsers}
                                        placeholder="Select or type a email"
                                        valueKey={"email"}
                                        filterKeys={["email", "full_name"]}
                                        value={values.emails}
                                        onChange={function (e, values) { handleChange({ target: { value: values, name: "emails" } }); }}
                                        disabled={isSubmitting}
                                        renderOption={(option) => {
                                            return (<OptionCard data={option} isSelected={[...sharedUserEmails, ...values.emails].indexOf(option.email) > -1} />);
                                        }}
                                    />
                                    {
                                        errors.emails && typeof errors.emails == "object" && (
                                            <div className="input-feedback" style={{ color: "red", paddingTop: 5 }}>Contains some invalid emails, please check.</div>
                                        )
                                    }
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: 10 }}>
                                    <RolesDropdown
                                        value={values.role_id}
                                        handleChange={handleChange}
                                        roles={roles}
                                        onRoleCreate={onRoleCreate}
                                        onRoleDelete={onRoleDelete}
                                        loadingRoles={loadingRoles}
                                    />
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || !dirty || Object.keys(errors).length > 0}>
                                        Send Invite &nbsp; {isSubmitting && <CircularProgress size={20} />}
                                    </Button>
                                </div>
                            </div>
                        </form>
                    );
                }
            }
        </Formik>
    );
}

export default observer(InviteByEmailForm);